import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { updateVideoStatus } from "../../../api/endpoints/VideoEndpoints";
import { Video } from "../../../models/Video";

export default function useUpdateVideoStatus() {
  return useMutation<
    void,
    AxiosError,
    { videoId: string; status: Video["status"] }
  >({
    mutationKey: ["update-video"],
    mutationFn: ({ videoId, status }) => updateVideoStatus(videoId, status),
  });
}
